import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { fmtDate, fmtDateTime } from "@/lib/format";

const STEP_BADGE = {
  pending: "bg-[#FEF3C7] text-[#92400E] border-[#FDE68A]",
  opened: "bg-[#DBEAFE] text-[#1E40AF] border-[#BFDBFE]",
  approved: "bg-[#DCFCE7] text-[#166534] border-[#BBF7D0]",
  rejected: "bg-[#FEE2E2] text-[#991B1B] border-[#FECACA]",
};
const money = (v) => (v == null ? "—" : `₹${Number(v).toLocaleString("en-IN")}`);

export default function ApprovalsTable({ approvals, showDecision }) {
  const navigate = useNavigate();
  return (
    <div className="overflow-x-auto rounded-lg border bg-card">
      <table className="w-full text-sm" data-testid="approvals-table">
        <thead>
          <tr className="border-b text-left text-xs uppercase tracking-wide text-muted-foreground">
            <th className="px-4 py-3 font-medium">Event ID</th>
            <th className="px-4 py-3 font-medium">Material</th>
            <th className="px-4 py-3 font-medium text-right">Sellers</th>
            <th className="px-4 py-3 font-medium text-right">Best Offer</th>
            <th className="px-4 py-3 font-medium">Tech Status</th>
            <th className="px-4 py-3 font-medium">Assigned</th>
            <th className="px-4 py-3 font-medium">Deadline</th>
            <th className="px-4 py-3 font-medium">Status</th>
            {showDecision && <th className="px-4 py-3 font-medium">Decision</th>}
            <th className="px-4 py-3 font-medium text-right">Action</th>
          </tr>
        </thead>
        <tbody>
          {approvals.length === 0 && (
            <tr><td colSpan={10} className="px-4 py-10 text-center text-muted-foreground" data-testid="approvals-empty">No approvals found.</td></tr>
          )}
          {approvals.map((a) => (
            <tr key={a.id} data-testid={`approval-row-${a.id.slice(0, 8)}`} className="border-b transition-colors last:border-0 hover:bg-slate-50">
              <td className="px-4 py-3 font-mono text-xs font-semibold">{a.enquiry_number}</td>
              <td className="px-4 py-3 text-xs">{a.material_summary}</td>
              <td className="px-4 py-3 text-right font-mono">{a.seller_count}</td>
              <td className="px-4 py-3 text-right font-mono text-xs font-semibold">{money(a.best_offer)}</td>
              <td className="px-4 py-3 text-xs capitalize">{a.tech_status.replace(/_/g, " ")}</td>
              <td className="px-4 py-3 text-xs">{a.assigned_at ? fmtDate(a.assigned_at) : "—"}</td>
              <td className={`px-4 py-3 text-xs ${a.overdue ? "font-semibold text-[#DC2626]" : ""}`}>{a.chain_deadline ? fmtDateTime(a.chain_deadline) : "—"}</td>
              <td className="px-4 py-3">
                <span data-testid={`approval-status-${a.id.slice(0, 8)}`} className={`rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase ${STEP_BADGE[a.overdue ? "pending" : a.status] || STEP_BADGE.pending}`}>
                  {a.overdue ? "Overdue" : a.status}
                </span>
              </td>
              {showDecision && <td className="px-4 py-3 text-xs capitalize">{a.decision}</td>}
              <td className="px-4 py-3 text-right">
                <Button size="sm" data-testid={`approval-open-${a.id.slice(0, 8)}`} onClick={() => navigate(`/approver/approvals/${a.id}`)}
                  className="bg-slate-900 hover:bg-slate-800">Review</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
